<div *ngIf="allow" style="display: flex; align-items: end; justify-content: end">
  <div class="vl-col--1-4" [formGroup]="form">
    <anb-dropdown
      label="{{ 'DOWNLOAD.FORM_LABEL' | translate }}"
      [form]="form"
      [formControlName]="'jaar'"
      [ase]="aseEnum.Ignore"
      [values]="dropdownValues"
    >
    </anb-dropdown>
  </div>
  <br />
</div>
<div class="vl-grid">
  <div class="vl-col--1-1 vl-u-align-right">
    <div *ngIf="form.get('jaar')?.value">
      <button class="vl-button" (click)="downloadCsv()">{{ 'DOWNLOAD.LABEL' | translate }}</button>
    </div>
  </div>
</div>
